import { useEffect, useState } from 'react';
import {API_URL} from '../creds'

const Dropdown = ({ selected, setSelected }) => {
  const [options, setOptions] = useState([]);

  useEffect(() => {
    const fetchMenu = async () => {
      try {
        const res = await fetch(`${API_URL}/menu`);
        const data = await res.json();
        setOptions(data);
      } catch (err) {
        console.error('Menu fetch error:', err);
      }
    };

    fetchMenu();
  }, []);

  return (
    <div className="mb-1">
      <label className="block text-xl font-medium text-gray-900 mb-0">
        Knowledge Source
      </label>

      <select
        value={selected}
        onChange={(e) => setSelected(e.target.value)}
        className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
      >
        <option value="">Select an option</option>

        {options
        .slice() // avoid mutating original array
        .sort((a, b) => a.description.localeCompare(b.description)) // alphabetical sort by description
        .map((item) => (
          <option key={item.projectid} value={item.projectid}>
            {/* {`${item.type} - ${item.person || "Unknown"} - ${item.subject || "No Subject"}`} */}
            {item.description}
          </option>
        ))}
      </select>
    </div>
  );
};

export default Dropdown;
